import * as React from 'react';
import { useContext } from 'react';

import type { CareerAcademy_Variant as CareerAcademyVariant } from '__generated__/graphql-types';

type CareerAcademyVariantContextType = {
  careerAcademyVariant?: CareerAcademyVariant;
  isCareerAcademyVariantLoading?: boolean;
};

const CareerAcademyVariantContext = React.createContext<CareerAcademyVariantContextType | undefined>(undefined);

export const useCareerAcademyVariant = () => {
  const programContext = useContext(CareerAcademyVariantContext);

  return programContext?.careerAcademyVariant;
};

export const useIsCareerAcademyVariantLoading = () => {
  const programContext = useContext(CareerAcademyVariantContext);

  return programContext?.isCareerAcademyVariantLoading;
};

export default CareerAcademyVariantContext;
